import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "header-button-visibility",
  class extends Controller {
    static targets = ["button"]

    connect() {
      this.handleElementEntered = this.handleElementEntered.bind(this)
      this.handleElementExited = this.handleElementExited.bind(this)

      document.addEventListener("element:entered", this.handleElementEntered)
      document.addEventListener("element:exited", this.handleElementExited)
    }

    disconnect() {
      document.removeEventListener("element:entered", this.handleElementEntered)
      document.removeEventListener("element:exited", this.handleElementExited)
    }

    handleElementEntered(event) {
      const { hidesHeaderButton } = event.detail
      if (hidesHeaderButton) this.hideButton()
    }

    handleElementExited(event) {
      const { hidesHeaderButton } = event.detail
      if (hidesHeaderButton) this.showButton()
    }

    hideButton() {
      if (this.hasButtonTarget) {
        this.buttonTarget.classList.add("opacity-0", "pointer-events-none")
        this.buttonTarget.classList.remove("opacity-100")
      }
    }

    showButton() {
      if (this.hasButtonTarget) {
        this.buttonTarget.classList.remove("opacity-0", "pointer-events-none")
        this.buttonTarget.classList.add("opacity-100")
      }
    }
  },
)
